import React, { Component } from "react";
import "semantic-ui-css/semantic.min.css";
import burroSmall from "../assets/images/burro_small.png";
import openAccess from "../assets/images/open_access.svg";
import SearchInputGrid from "../components/liminal/SearchInputGrid";
import PageFooter from "../components/liminal/PageFooter";
import PageHeader from "../components/liminal/PageHeader";
import { Container, Grid, Image } from "semantic-ui-react";
import OpenSeadragon from "openseadragon";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: this.props.search.searchTerm,
    };
  }

  componentDidMount() {
    this.initOpenseadragon();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
      this.initOpenseadragon();
    }
  }

  initOpenseadragon() {
    setTimeout(() => {
      const elem = document.getElementById("viewer");
      const hostname = window.location.hostname;
      if (elem) {
        const osd = OpenSeadragon({
          id: "viewer",
          tileSources: [
            {
              x: 0,
              y: 0,
              width: 1000,
              tileSource: `https://${hostname}/nco/handwritten.dzi`,
            },
          ],
          prefixUrl: "/openseadragon/images/",
          showNavigator: false,
          showNavigationControl: true,
          showFullPageControl: true,
        });

        osd.addHandler("canvas-double-click", (event) => {
          const viewer_point = osd.viewport.pointFromPixel(event.position);
          const width = 78807;
          const height = 53816;
          const x = viewer_point.x / 1000;
          const y = ((width / height) * viewer_point.y) / 1000;

          const url = `${process.env.REACT_APP_METABOTNIK_API_URL}xy/nco20201123/${x}_${y}`;
          fetch(url)
            .then((response) => {
              if (response.ok) return response.text();
            })
            .then((anID) => {
              if (anID) {
                const href = `${
                  process.env.PUBLIC_URL
                }/view/${anID}/makingsense`;
                window.open(href, "NCO_showdetails");
              }
            });
        });
      }
    }, 0);
  }

  doSearch = () => {
    this.setState({ searching: true });
    this.props.search.searchTerm = this.state.searchTerm;
    this.props.search.doSearch("makingsense", () => {
      this.props.history.push(
        `${process.env.REACT_APP_URL_PATH}/section/makingsense`
      );
    });
  };
  render() {
    return (
      <div className="home-page wrapper">
        <PageHeader search={this.props.search} history={this.props.history} />

        <div className="parallax large handwritten-oort">
          <Container className="overlay">
            <Grid
              verticalAlign="middle"
              className="entrypoint"
              columns={2}
              stackable
            >
              <Grid.Column width={6}>
                <Image
                  src={burroSmall}
                  size="large"
                  className="burro-home"
                  centered
                />
              </Grid.Column>
              <Grid.Column width={10}>
                <div className="title">
                  <h1>Natuurkundige Commissie Archives Online</h1>
                  <h2>
                    Providing access to the hidden treasures of the
                    ‘Natuurkundige Commissie voor Nederlandsch-Indië’
                    (1820-1850)
                  </h2>
                </div>
              </Grid.Column>
            </Grid>

            <SearchInputGrid
              searchTerm={this.state.searchTerm}
              searching={this.state.searching}
              onChange={(event) =>
                this.setState({ searchTerm: event.target.value })
              }
              doSearch={this.doSearch}
            />
          </Container>
        </div>

        <Container text className="parallax__text-block">
          <Grid columns={2} divided centered>
            <Grid.Column width={7}>
              <Grid columns={2}>
                <Grid.Column width={4}>
                  <Image
                    src={openAccess}
                    size="tiny"
                    href="https://en.wikipedia.org/wiki/Open_access"
                    className="open-access"
                    title="Open access"
                  />
                </Grid.Column>
                <Grid.Column width={12}>
                  <h4>Open access</h4>
                  <p>
                    This collection is completely <em>open access</em>, meaning
                    everything is fully accessible without any charge.
                  </p>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column width={8}>
              <h4>Cite this collection</h4>
              <p className="citation">
                Gassó, E., Stork, L., Weber, A., Ameryan, M., Wolstencroft K,{" "}
                <i>Natuurkundige Commissie Archives Online</i>. Leiden: Brill,
                2020. doi:10.1163/9789004336865
              </p>
            </Grid.Column>
          </Grid>
          <h1>The archive of the Natuurkundige Commissie</h1>
          <p>
            <i>
              The archive of the Natuurkundige Commissie voor Nederlands-Indië
            </i>{" "}
            is maintained by the Library & Archives department of Naturalis
            Biodiversity Center in Leiden. Due to a restoration and digitization
            project funded by the Royal Library of the Netherlands’ Metamorfoze
            fund between 2007 and 2012, the archive is in good condition and
            almost entirely digitally available. It consists of the following
            categories:
          </p>
        </Container>

        <div className="parallax published" />

        <Container text className="parallax__text-block">
          <h3>Published material</h3>
          <p>
            This collection contains 2.088 pages of published material. This
            concerns the standard work{" "}
            <i>
              Verhandelingen over de natuurlijke geschiedenis der Nederlandsche
              overzeesche bezittingen door de leden der Natuurkundige Commissie
              in Indië en andere schrijvers
            </i>
            , published between 1839 and 1844. This work consists of three
            volumes treating the subjects I. geography and anthropology II.
            botany and III. zoology. Hundreds of new species are described in
            this work, which also contains numerous unique drawings of animals,
            plants, landscapes and indigenous culture.
          </p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Obook`}
            >
              Browse all publications
            </a>
          </p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Obookillustration`}
            >
              Browse all publication fragments
            </a>
          </p>
        </Container>

        <div className="parallax large images" />

        <Container text className="parallax__text-block">
          <h3>Images</h3>
          <p>
            There are 1.204 individual sketches, drawings and other scientific
            images of exceptionally high quality in this collection. Some of
            these are the original drawings of the images that were published in
            the Verhandelingen mentioned above.
          </p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Oimage`}
            >
              Browse all images
            </a>
          </p>

          <p>
            The images are organised in folders. Sometimes the the folder itself
            is just a page with several drawings.
          </p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Ocontainer`}
            >
              Browse all image folders
            </a>
          </p>
        </Container>

        <div className="parallax handwritten" />

        <Container text className="parallax__text-block">
          <h3>Handwritten documents</h3>
          <p>
            There are 13.958 pages of diary entries, field notes, expedition
            reports, transport lists, correspondence and other forms of
            information. These documents have been handwritten by various
            committee members, in different languages (Dutch, German, French and
            Latin) and often under difficult circumstances. Because of this, the
            material is hardly accessible to the untrained eye.
          </p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Ohandwritten`}
            >
              Browse all handwritten documents
            </a>
          </p>

          <p>The documents are organised in folders.</p>
          <p>
            <a
              href={`${
                process.env.PUBLIC_URL
              }/section/makingsense?facet_tipe=Ocontainer`}
            >
              Browse all handwritten document folders
            </a>
          </p>
        </Container>

        <div className="parallax large landscape" />

        <Container text className="parallax__text-block">
          <h3>Start your discovery</h3>
          <p>
            Start{" "}
            <a href={`${process.env.PUBLIC_URL}/section/makingsense`}>
              searching
            </a>{" "}
            in the collection, or use the Metabotnik viewer below for a visual
            overview.
          </p>
          <p>
            <b>Double-click on an item to view:</b>
          </p>
        </Container>

        <div
          id="viewer"
          style={{ width: "100%", height: "70vh", backgroundColor: "#ffffff" }}
        />

        <PageFooter />
      </div>
    );
  }
}

export default Home;
